import React from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

const hasCompleteAvailableCapacity = preflight =>
  preflight?.status === "available" &&
  Number.isInteger(preflight?.used) &&
  Number.isInteger(preflight?.maximum) &&
  Number.isInteger(preflight?.remaining);

export default function WhatsAppAddNumberConfirmModal({
  open,
  preflight,
  accountDisplayName,
  onCancel,
  onContinue,
  isContinuing = false,
}) {
  const isAvailable = preflight?.status === "available";
  const showCapacity = hasCompleteAvailableCapacity(preflight);

  return (
    <Dialog
      open={open}
      onOpenChange={nextOpen => !nextOpen && !isContinuing && onCancel()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-lg font-bold text-slate-900">
            Add another WhatsApp number
          </DialogTitle>
        </DialogHeader>

        <DialogDescription className="space-y-4 text-sm leading-6 text-slate-600">
          {showCapacity ? (
            <span className="block rounded-lg bg-slate-50 px-4 py-3">
              <span className="block font-semibold text-slate-800">
                {preflight.used} of {preflight.maximum} numbers used
              </span>
              <span className="block">
                {preflight.remaining} {preflight.remaining === 1 ? "slot" : "slots"} available
              </span>
            </span>
          ) : isAvailable ? (
            <span className="block">
              Capacity is available for another WhatsApp number.
            </span>
          ) : (
            <span className="block">
              We couldn't confirm your current Meta phone-number limit. Meta will perform the final eligibility check during setup.
            </span>
          )}

          {accountDisplayName && (
            <span className="block">
              Existing WhatsApp account: <strong>{accountDisplayName}</strong>
            </span>
          )}

          <span className="block">
            This number must be added to the existing WhatsApp Business Account already connected to XploreByte.
          </span>

          <span className="block rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-emerald-950">
            <strong className="block">Select your existing WhatsApp Business Account.</strong>
            <span className="block">Do not create a new WhatsApp Business Account.</span>
          </span>
        </DialogDescription>

        <DialogFooter>
          <DialogClose asChild>
            <button
              type="button"
              disabled={isContinuing}
              className="rounded-lg border border-slate-200 bg-white px-4 py-2 text-xs font-bold text-slate-700 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
            >
              Cancel
            </button>
          </DialogClose>
          <button
            type="button"
            onClick={onContinue}
            disabled={isContinuing}
            className="rounded-lg bg-emerald-600 px-4 py-2 text-xs font-bold text-white hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isContinuing ? "Opening Meta..." : "Continue to Meta"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
